exports.Observable = require("zen-observable/index.js");
